import { Controller } from '../utils/controller';
import { isMobile } from '../utils/ismobile';

export default class extends Controller {
  static targets = [
    'dropdownFilter',
    'toggleIcon',
    'filterPopupWrapper',
    'overlayFilterCaret',
    'overlayFilterButton',
    'overlayFilterWrapper'
  ];
  static requiredTargets = [];

  static classes = [
    'maxheights',
    'textcolors',
    'popupFilter',
    'overlayFilterOpen',
    'sortByOpen',
    'sortBySvg'
  ];
  static requiredClasses = [];

  // TARGETS
  declare dropdownFilterTargets;
  declare filterPopupWrapperTarget;
  declare overlayFilterCaretTarget;
  declare overlayFilterWrapperTarget;
  declare toggleIconTargets: HTMLElement[];

  declare readonly hasOverlayFilterCaretTarget: boolean;
  declare readonly hasOverlayFilterWrapperTarget: boolean;
  declare readonly hasDropdownFilterTarget: boolean;
  declare readonly hasFilterPopupWrapperTarget: boolean;
  declare readonly hasToggleIconTarget: boolean;

  // CLASSES
  declare maxheightsClasses: string[];
  declare overlayFilterOpenClass: string;
  declare popupFilterClasses: string[];
  declare textcolorsClasses: string[];
  declare readonly hasOverlayFilterOpenClass: boolean;

  connect() {
    window.addEventListener('dynamic_top:mobile', (event: Event) => {
      if (isMobile()) {
        const header = document.getElementsByTagName('header')[0];
        const { target } = event;
        if (target) {
          const element = target as HTMLElement;
          element.style.top = `${header.offsetHeight + header.offsetTop}px`;
          element.style.height = `calc(100% - ${top}px)`;
        }
      }
    });
  }

  toggleDropdown(event) {
    const button = event.target;
    const index = button.dataset.dropdownIndex;

    for (const cl of this.textcolorsClasses) {
      button.classList.toggle(cl);
    }

    if (this.hasDropdownFilterTarget) {
      for (const cl of this.maxheightsClasses) {
        this.dropdownFilterTargets[index].classList.toggle(cl);
      }
    }

    if (this.hasToggleIconTarget) {
      if (button.dataset.collapsed === 'true') {
        this.toggleIconTargets[index].innerText = '-';
        button.dataset.collapsed = 'false';
      } else {
        this.toggleIconTargets[index].innerText = '+';
        button.dataset.collapsed = 'true';
      }
    }
  }

  toggleOverlayDropdown(event) {
    const button = event.target;
    const index = button.dataset.dropdownIndex;

    for (const cl of this.textcolorsClasses) {
      button.classList.toggle(cl);
    }
    if (this.hasDropdownFilterTarget) {
      for (const cl of this.maxheightsClasses) {
        this.dropdownFilterTargets[index].classList.toggle(cl);
      }
    }
    if (this.hasOverlayFilterCaretTarget && this.hasOverlayFilterOpenClass) {
      this.overlayFilterCaretTarget.classList.toggle(this.overlayFilterOpenClass);
    }
  }

  toggleOverlayFilter() {
    if (this.hasOverlayFilterWrapperTarget) {
      this.overlayFilterWrapperTarget.classList.toggle('hidden');
    }
  }

  showPopupFilter() {
    if (this.hasFilterPopupWrapperTarget) {
      this.filterPopupWrapperTarget.classList.add(...this.popupFilterClasses);
      this.filterPopupWrapperTarget.classList.remove('hidden');
    }
  }

  closePopupFilter() {
    if (this.hasFilterPopupWrapperTarget) {
      this.filterPopupWrapperTarget.classList.remove(...this.popupFilterClasses);
      this.filterPopupWrapperTarget.classList.add('hidden');
    }
  }
}
